/* COLD SCHOOL — drop countdown. Three states, timezone-aware, never shows 00:00:00 stalled. */
(function () {
  'use strict';
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var openAt = new Date(el.dataset.open).getTime();
    var closeAt = new Date(el.dataset.close).getTime();
    if (isNaN(openAt) || isNaN(closeAt)) { return; }

    var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'),
        m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    var label = el.querySelector('[data-cd-label]'), title = el.querySelector('[data-cd-title]'),
        sub = el.querySelector('[data-cd-sub]'), clock = el.querySelector('[data-cd-clock]'),
        ctaWrap = el.querySelector('[data-cd-cta-wrap]'), cta = el.querySelector('[data-cd-cta]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function paint(target) {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var sec = Math.floor(diff / 1000);
      d.textContent = pad(Math.floor(sec / 86400));
      h.textContent = pad(Math.floor((sec % 86400) / 3600));
      m.textContent = pad(Math.floor((sec % 3600) / 60));
      s.textContent = pad(sec % 60);
    }

    var state = '';
    function render() {
      var now = Date.now();
      var next;
      if (now < openAt) {
        if (state !== 'pre') {
          state = 'pre';
          el.setAttribute('data-state', 'pre');
          label.textContent = el.dataset.drop;
          title.textContent = el.dataset.openLine;
          sub.textContent = el.dataset.openWhen;
          clock.style.display = '';
          ctaWrap.style.display = 'none';
        }
        next = openAt;
        paint(next);
      } else if (now < closeAt) {
        if (state !== 'open') {
          state = 'open';
          el.setAttribute('data-state', 'open');
          label.textContent = el.dataset.drop;
          title.textContent = el.dataset.liveLine;
          sub.textContent = el.dataset.closeWhen;
          clock.style.display = '';
          ctaWrap.style.display = '';
          cta.textContent = el.dataset.cta;
          cta.setAttribute('href', el.dataset.shopUrl);
        }
        next = closeAt;
        paint(next);
      } else {
        if (state !== 'closed') {
          state = 'closed';
          el.setAttribute('data-state', 'closed');
          label.textContent = el.dataset.drop;
          title.textContent = el.dataset.closedLine;
          sub.textContent = '';
          clock.style.display = 'none';
          if (el.dataset.closedCta) {
            ctaWrap.style.display = '';
            cta.textContent = el.dataset.closedCta;
            cta.setAttribute('href', el.dataset.closedUrl || '#');
          } else {
            ctaWrap.style.display = 'none';
          }
        }
        return; // stop ticking
      }
    }

    render();
    var timer = setInterval(function () {
      render();
      if (state === 'closed') clearInterval(timer);
    }, 1000);
  });
})();
